const $ = jQuery;

$(document).ready(function () {
	// const form = document.getElementById("frm_form_35_container");
	const form = document.querySelector("#frm_form_35_container .frm_form_fields .frm_fields_container ");
	if (form) {
		const entryField = form.querySelector("#field_klx3s");
		const selectLPField = form.querySelector('[name="item_meta[244]"]');
		const finalSubmit = form.querySelector(".frm_final_submit");
		if (!selectLPField.value) {
			finalSubmit.setAttribute("disabled", true);
		} else {
			// finalSubmit.removeAttribute("disabled");
		}
		let entryId;
		const addGoalBtn = form.querySelector(".frm_add_form_row");
		let url = "/wp-admin/admin-ajax.php";
		let goals = [];
		let count;
		// console.log(entryField);
		selectLPField.addEventListener("change", getGoals.bind());

		function getGoals(e) {
			// console.log(e);

			let isEntry = setInterval(() => {
				if (entryField.value) {
					entryId = entryField.value;
					clearInterval(isEntry);
					runGetGoals();
				}
			}, 1500);
		}

		function runGetGoals() {
			if (entryId) {
				$.ajax({
					type: "POST",
					url: url,
					dataType: "json",
					data: {
						action: "ocfp_get_goals",
						entryId: entryId,
					},
					success: async function (res) {
						finalSubmit.setAttribute("disabled", true);
						console.log(res);
						goals = res.goals;
						count = res.goal_count;
						let checkRepeaterSections;
						checkRepeaterSections = setInterval(() => {
							const repeaterSections = form.querySelectorAll("#frm_field_232_container .frm_repeat_232");
							if (repeaterSections.length < count) {
								addGoalBtn.click();
								// console.log("is not cleared");
							} else {
								clearInterval(checkRepeaterSections);
								// console.log("is cleared");
								if (goals.length && repeaterSections) {
									repeaterSections.forEach((section, index) => {
										const learningGoal = section.querySelector('[name*="[235]"]');
										const learningTopic = section.querySelector('[name*="[355]"]');
										const learningScale = section.querySelector('[name*="[237]"]');
										const goalUniqueId = section.querySelector('[name*="[251]"]');
										const goalStatus = section.querySelector('[name*="[248]"]');

										learningGoal.value = goals[index].learning_goal;
										learningTopic.value = goals[index].learning_topic;
										const options = learningScale.querySelectorAll("option");
										options.forEach((opt) => opt.removeAttribute("selected"));
										options[+goals[index].learning_scale - 1].setAttribute("selected", "selected");
										learningScale.value = goals[index].learning_scale;
										learningScale.selectedIndex = +goals[index].learning_scale - 1;
										learningScale.setAttribute("data-frmval", goals[index].learning_scale);

										console.log(`value: ${learningScale.value}`);
										console.log(`selectedIndx: ${learningScale.selectedIndex}`);
										console.log(`data: ${learningScale.getAttribute("data-frmval")}`);

										goalUniqueId.value = goals[index].unique;
										// console.log(goals[index].goal_status);
										if (goals[index].goal_status == "Yes") {
											goalStatus.checked = true;
											goalStatus.nextElementSibling.setAttribute("aria-checked", true);
										}
									});
								}
								finalSubmit.removeAttribute("disabled");
							}
						}, 1500);
					},
				});
			}
		}
	}
});
